import React, {useState} from 'react'
import {GG_ID} from "../../../envs/_current/config";
import {FcGoogle} from "react-icons/fc";
import Translate from "../../../modules/local/Translate";
import {message, Spin} from "antd";
import classNames from "classnames";


export default function GoogleLoginBtn({
                                           onSuccess, label = 'Sign in with Google'
                                       }) {
    const [loading, setLoading] = useState(false);
    const responseGoogleViaMob = () => {
        try {
            setLoading(true);
            window.plugins.googleplus.login(
                {
                    // scopes: 'profile email', // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
                    webClientId: GG_ID,
                    offline: true // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
                },
                obj => {
                    if (obj['accessToken']) {
                        onSuccess({
                            token: obj.accessToken,
                            provider: 'google'
                        })
                    }
                    setTimeout(() => {
                        setLoading(false);
                    }, 500)
                },
                msg => {
                    // alert('error: ' + msg)
                    setLoading(false);
                    message.info('error: ' + msg + '. Try again')
                }
            )
        } catch (e) {
            setLoading(false);
            message.info('not undefined: googleplus')
            // alert("not undefined: googleplus");
        }
    }
    return (
        <Translate>
            {(t) => (
                <button
                    onClick={responseGoogleViaMob}
                    className="
                flex items-center justify-center
                bg-white text-color-000
                border border-gray-300
                rounded-lg cursor-pointer
                hover:shadow-md transition-shadow duration-200
                py-3 px-6 gap-3
                w-full
            "
                    style={{
                        minHeight: '44px', // Chiều cao tối thiểu theo hướng dẫn của Apple
                        fontSize: '15px', // Kích thước chữ chuẩn của Apple
                        fontWeight: '500', // Semibold theo Apple (Tailwind's font-semibold is 600)
                        fontFamily: 'SF Pro Text, SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial, sans-serif', // Font chữ ưu tiên của Apple
                        letterSpacing: '0.03em', // Khoảng cách chữ nhẹ
                    }}
                >
                    <FcGoogle size={17}/>

                    <span
                        className={classNames("leading-none", loading ? "text-color-300 italic" : "text-color-000")}>
                        {loading ? t('logging in...') : t(label)}</span>
                    {
                        loading && <Spin spinning/>
                    }
                </button>
            )}
        </Translate>
    )
}